<template>
    <div class="TenantsPage">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="float-right">
                        <b-button v-on:click="go_back">Log Out</b-button>
                    </div>
                    <div class="text-left welcome">Welcome, <b>{{ loginData.webname }} </b>
                    </div>
                    <br/>

                    <div role="tablist" class="tablist-space">
                        <b-card no-body class="mb-1" v-for="(b,index) in loginData.Buildings"
                                :key="index"
                        >
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block href="#" v-b-toggle="'ad'+index" variant="info">
                                    <div class="float-right">
                                        <div class="btn-container">
                                            <div class="btn-floater">
                                                <b-button variant="outline-primary"
                                                          @click.stop="showPdfModal(b.AccNo,b.RentRolls)">Rent Rolls
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-left building">{{ b.BuildingName }}</div>
                                </b-button>
                            </b-card-header>
                            <b-collapse v-bind:id="'ad'+index" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <block-page :tenants="b.Tenants" @showModal="showModal"></block-page>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>

                    <b-alert variant="danger" dismissible v-model="showNoData">
                        You have no accounts linked to your email, contact us to fix it!
                    </b-alert>
                </div>
            </div>
        </div>
        <!-- Modal Component -->
        <b-modal show ref="noteModal" id="modalnote" title="Notes" size="xl">
            <pre class="text-left my-pre">
{{ currentNote }}</pre>
            <div slot="modal-footer">
                <b-button v-on:click="hideModal">Close</b-button>
            </div>
        </b-modal>
        <!-- PDF Modal Component-->
        <b-modal id="pdf-modal" ref="pdfModal" title="Rent Rolls - Click to Open" size="sm">
            <div v-bind:key="x" v-for="x in currentPdfs">
                <div class="pdf-spacing">
                    <b-button variant="outline-danger" :href="downloadLink + x " target="_blank">{{ x }}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

    import BlockPage from "./BlockPage/BlockPage";

    export default {
        components: {BlockPage},
        mounted: function () {
            if (this.loginData.Buildings.length === 0) {
                this.showNoData = true;
            }
        },
        methods: {
            showPdfModal(building, RentRolls) {
                this.currentBuilding = building;
                this.currentPdfs = RentRolls;
                this.$refs.pdfModal.show();
            },
            showModal(note) {
                this.currentNote = note;
                if (!note || note.toString().trim() === "") {
                    this.currentNote = "No Notes found!";
                }

                this.$refs.noteModal.show();
            },
            hideModal() {
                this.$refs.noteModal.hide()
            },
            go_back() {
                this.$emit("log_out");
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }
        },
        data() {
            return {
                currentNote: "",
                currentBuilding: "",
                currentPdfs: [],
                tenantsProp: this.tenants,
                showNoData: false,
                rows: [
                    {id: 1, name: "John", birth: "2004-05-19", year: "5", number: "17"},
                    {id: 2, name: "Jane", birth: "2004-05-19", year: "6", number: "18"},
                    {id: 3, name: "Susan", birth: "2004-05-19", year: "7", number: "19"},
                    {id: 4, name: "Chris", birth: "2004-05-19", year: "8", number: "20"},
                    {id: 5, name: "Dan", birth: "2004-05-19", year: "9", number: "21"}
                ]
            }
        },
        computed: {
            downloadLink: function () {
                return this.apihost + "DownloadPdf?building=" + this.currentBuilding + "&_sid=" + this.loginData.SID + "&pdfname=";
            }
        },
        props: {
            loginData: Object,
            tenants: Array,
        },
    };
</script>

<style>
    .my-pre {
        white-space: pre-wrap;
        margin: 0;
    }

    .building {
        font-size: 20px;
    }

    .welcome {
        font-size: 18px;
    }

    .tablist-space {
        padding-right: 100px;
    }

    .btn-container {
        position: relative;
    }

    .btn-floater {
        position: absolute;
        left: 21px;
        width: 100px;
        top: -4px
    }
    .pdf-spacing {
        padding-top: 8px;
    }
</style>
